import moment from "moment"

const initialState = {
  isLoading: false,
  repairs: [],
  totalRepairs: 0,
  totalPages: 0,
  currentRepair: null,
  newRepair: {
    reportDate: moment().format("YYYY-MM-DD"),
    repairReceivedNote: "",
    installerCompany: "",
    itemsOfRepair: [],
    productModel: "",
    productSerialNumber: "",
    invoiceNumber: "",
    errorDescription: "",
    typesOfRepair: [],
    sparePartsUsed: [],
    technician: "",
  },
}

const RepairReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_REPAIR_LOADING":
      return {
        ...state,
        isLoading: action.data,
      }
    case `SET_REPAIRS`:
      return {
        ...state,
        repairs: action.data,
      }

    case `SET_TOTAL_REPAIRS`:
      return {
        ...state,
        totalRepairs: action.data,
      }

    case `SET_TOTAL_PAGES`:
      return {
        ...state,
        totalPages: action.data,
      }

    case `SET_CURRENT_REPAIR`:
      return {
        ...state,
        currentRepair: action.data,
      }

    case `SET_REPAIR_DATE`:
      return {
        ...state,
        newRepair: { ...state.newRepair, reportDate: action.data },
      }

    case `SET_RRN_REFERENCE`:
      return {
        ...state,
        newRepair: { ...state.newRepair, repairReceivedNote: action.data },
      }

    case `SET_INSTALLER_NAME`:
      return {
        ...state,
        newRepair: { ...state.newRepair, installerCompany: action.data },
      }

    case `SET_ITEMS_OF_REPAIR`:
      return {
        ...state,
        newRepair: { ...state.newRepair, itemsOfRepair: action.data },
      }

    case `SET_PRODUCT_MODEL`:
      return {
        ...state,
        newRepair: { ...state.newRepair, productModel: action.data },
      }

    case `SET_PRODUCT_SERIAL_NUMBER`:
      return {
        ...state,
        newRepair: { ...state.newRepair, productSerialNumber: action.data },
      }

    case `SET_INVOICE_NUMBER`:
      return {
        ...state,
        newRepair: { ...state.newRepair, invoiceNumber: action.data },
      }

    case `SET_ERROR_DESCRIPTION`:
      return {
        ...state,
        newRepair: { ...state.newRepair, errorDescription: action.data },
      }

    case `ADD_TYPE_OF_REPAIR`:
      return {
        ...state,
        newRepair: {
          ...state.newRepair,
          typesOfRepair: [...state.newRepair.typesOfRepair, action.data],
        },
      }

    case `REMOVE_TYPE_OF_REPAIR`:
      return {
        ...state,
        newRepair: {
          ...state.newRepair,
          typesOfRepair: state.newRepair.typesOfRepair.filter(
            (_, index) => index !== action.data
          ),
        },
      }

    case `SET_TYPES_OF_REPAIR`:
      return {
        ...state,
        newRepair: { ...state.newRepair, typesOfRepair: action.data },
      }

    case `SET_SPARE_PARTS_USED`:
      return {
        ...state,
        newRepair: { ...state.newRepair, sparePartsUsed: action.data },
      }

    case `SET_TECHNICIAN`:
      return {
        ...state,
        newRepair: { ...state.newRepair, technician: action.data },
      }

    case `CLEAR_NEW_REPAIR`:
      return {
        ...state,
        newRepair: { ...initialState.newRepair },
      }

    default:
      return state
  }
}

export default RepairReducer
